import PathMatrix from "csi/table/matrix/Path";
import _ from "csi/_base/underscore";
import declare from "dojo/_base/declare";

const StyleBOMsMatrix = declare(PathMatrix, {
	/**
     * @override
     * Filters DataSheets that are not of ApparelBOM type
     */
	_filterNodes (ctx, spec, nodes) {
		return _.filter(nodes, (node) => {
			return node.$Type === "ApparelBOM";
		});
	},
});

export = StyleBOMsMatrix;
